import { combineReducers } from 'redux';
import AppSettings from './AppSettings/reducer';
import User from './Users/reducer';
import Alerts from './Alerts/reducer';

const rootReducer = combineReducers({
  AppSettings, User, Alerts
});

export default rootReducer;
